import cxs from 'cxs';
import { COLOURS, SHADOWS } from '../../../common/styles/vars';

export const BTN_CONTAINER = cxs({
  display: 'inline-flex',
  backgroundRepeat: 'no-repeat',
  border: 'none',
  cursor: 'pointer',
  outline: 'none',
  flexDirection: 'column',
  borderRadius: '3px',
  backgroundColor: 'transparent'
});

export const POPUP_CONTAINER = cxs({
  cursor: 'pointer',
  backgroundColor: COLOURS.mono.white,
  borderRadius: '8px',
  boxShadow: SHADOWS.soft,
  paddingTop: '5px',
  paddingBottom: '5px',
  marginTop: '5px',
  zIndex: 105,
  '-webkit-app-region': 'no-drag'
});